export class HighlightLayer {
  constructor(svgGroup, nodeBoundsById) {
    this.group = svgGroup
    this.nodeBoundsById = nodeBoundsById
    this.rectsById = {}
  }

  highlight(nodeId, colour) {
    this.unhighlight(nodeId)
    const bounds = this.nodeBoundsById[nodeId]
    if (!bounds) return

    const svgNS = "http://www.w3.org/2000/svg"
    const rect = document.createElementNS(svgNS, "rect")
    rect.setAttribute("x", bounds.x)
    rect.setAttribute("y", bounds.y)
    rect.setAttribute("width", bounds.width)
    rect.setAttribute("height", bounds.height)
    rect.setAttribute("fill", colour)
    rect.setAttribute("opacity", "0.2")
    rect.setAttribute("style", "pointer-events: none")

    this.group.appendChild(rect)
    this.rectsById[nodeId] = rect
  }

  unhighlight(nodeId) {
    const rect = this.rectsById[nodeId]
    if (rect) {
      rect.parentNode.removeChild(rect)
      delete this.rectsById[nodeId]
    }
  }
}
